import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getreagentsHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.dynamicList({ path: "reagentsandchemicals", ...action.payload }),
		);
		yield put({
			type: types.GET_REAGENTS_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_REAGENTS_ERROR,
			payload,
		});
	}
}

export function* getreagentsWatcherSaga() {
	yield takeLatest(types.GET_REAGENTS_START, getreagentsHandlerSaga);
}

//create

//delete

function* deletereagentsHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.delete,
			endPoint.deleteDyanamicItem("reagentsandchemicals", action.payload),
		);
		yield put({
			type: types.DELETE_REAGENTS_SUCCESS,
			payload: data,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.DELETE_REAGENTS_ERROR,
			payload,
		});
	}
}

export function* deletereagentsWatcherSaga() {
	yield takeLatest(types.DELETE_REAGENTS_START, deletereagentsHandlerSaga);
}

//update
